module.exports = __webpack_public_path__ + "static/media/aman-verma.8eead4b2.jpeg";